import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-view-topics',
  templateUrl: './view-topics.component.html',
  styleUrls: ['./view-topics.component.scss']
})
export class ViewTopicsComponent implements OnInit {
  @Input() students: any[] = [];
  selectedIndex = 0;
  constructor(public modal: NgbActiveModal) { }

  ngOnInit(): void {}
  
  selectStudent(index: number): void {
    this.selectedIndex = index;
  }
}
